import angular from 'angular';
import employeeCreateComponent from './employee-create.component';
import chargeCodeTable from './components/chargecode-table/chargecode-table'
let employeeCreateModule = angular.module('employeeCreate', [
  chargeCodeTable.name
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('employeeCreate', employeeCreateComponent);

export default employeeCreateModule;



// WEBPACK FOOTER //
// ./client/pages/admin/employee-create/employee-create.js